<template>
  <div v-show="show">
    <b-card title="Currículo" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12 col-sm-6"
          label="* Nome"
          label-for="name"
          description="">

          <b-form-input id="name"
            v-model="form.name"
            placeholder="Titulo"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }"
            @input="slugify">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-sm-6"
          label="Slug"
          label-for="slug"
          description="(Se vazia será gerada uma slug automática)">

          <b-form-input id="slug"
            v-model="form.slug"
            placeholder="Slug"
            :class="{
              'is-invalid': submitted && form.errors.has('slug'),
              'is-valid': submitted && !form.errors.has('slug')
            }"
            @change="userEditedSlug = true">
          </b-form-input>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group class="col-12"
          label="Subtítulo"
          label-for="subtitle"
          description="(Obrigatório)">

          <rich-textarea v-model="form.subtitle"
            :height="200"
            name="subtitle"
            :toolbar="[
              ['font', ['bold', 'italic', 'underline', 'clear']],
              // ['fontsize', ['fontsize']],
              // ['para', ['ul', 'ol', 'paragraph']],
              // ['color', ['color']],
              // ['insert', ['link', 'hr']]
              ['insert', ['link']]
            ]"
            ></rich-textarea>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group class="col-12"
          label="Currículo"
          label-for="resume"
          description="(Obrigatório)">

          <rich-textarea v-model="form.resume"
            :height="200"
            name="resume"
            :toolbar="[
              ['font', ['bold', 'italic', 'underline', 'clear']],
              // ['fontsize', ['fontsize']],
              // ['para', ['ul', 'ol', 'paragraph']],
              // ['color', ['color']],
              // ['insert', ['link', 'hr']]
              ['insert', ['link']]
            ]"
            ></rich-textarea>
        </b-form-group>
      </div>
      <slot name="footer"></slot>
    </b-card>

  </div>
</template>

<script>
import slugify from 'slugify'
import { get, set } from 'lodash'
import { resolveHTTP } from '@/services/api'
import { slugifyOptions } from '@/plugins'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      processing: false,
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        types: true,
        items: true
      },

      selectedProcess: null,
      processes: [],

      selectedType: null,
      types: [],

      processItemEntity: null,
      items: [],
      resume: '',
      subtitle: '',

      empty: {
        name: '',
        slug: null,
        process_id: null,
        type_id: null,
        resume: '',
        subtitle: '',
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps) {
        if (!get(newProps, 'form.process_id', false)) {
          this.selectedProcess = null
        }

        if (!get(newProps, 'form.type_id', false)) {
          this.selectedType = null
        }
      },
      resume (next) {
        set(this.form, 'resume', next)
      },
      subtitle (next) {
        set(this.form, 'subtitle', next)
      },
      deep: true
    }
  },

  computed: {
    ready () {
      return !(this.locks.processes || this.locks.types || this.locks.items)
    }
  },

  methods: {
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    slugify () {
      const self = this

      if (this.userEditedSlug) {
        return
      }

      self.show = false
      self.form.slug = slugify(self.form.name, slugifyOptions)
      self.$nextTick(() => {
        self.show = true
      })
    },

    handleUploadFile (file, response, progress) {
      // If the upload was successful we need to generate to insert the file on the items collection
      // or update the list completly
      this.items.push(response)
      // if (this.form._attach_files === undefined) {
      //   this.form._attach_files = this.form.initial._attach_files || []
      // }
      // this.form._attach_files.push(response)
      // this.file = response
    },

    handleDrop ({ newIndex, oldIndex }) {
      const self = this

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true
        let previousId = null

        if (newIndex !== 0) {
          previousId = get(self.items[newIndex - 1], 'id', null)
        }

        let elementId = get(self.items[newIndex], 'id')

        self.processItemHttp.resource.put(`${elementId}/after/${previousId || ''}`)
          .finally(() => {
            self.processing = false
          })
      }
    }
  },

  created () {
    const self = this

    resolveHTTP('/bl/processes').index({ params: { _onepage: true } })
      .then(function (res) {
        self.processes = res.data.collection
        self.locks.processes = false

        self.selectedProcess = self.form.process_id
          ? self.processes.find((o) => o.id === self.form.process_id)
          : null
      })

    self.types = [
      { id: 1, name: 'Imagem' },
      { id: 2, name: 'Video' },
      { id: 4, name: 'Arquivos' }
    ]

    self.selectedType = self.form.type_id
      ? self.types.find((o) => o.id === self.form.type_id)
      : null

    self.locks.types = false
    if (self.instance.id) {
      self.form.setInitialValues(self.instance)
      self.resume = self.instance.resume
      self.subtitle = self.instance.subtitle
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/Resume.vue